import { Volume2, Square } from "lucide-react";

// Vollbild-Countdown bis zum zeitgleichen Gruppenstart (Messe + Event-Seite).
// run = { target (ms, Handyuhr), label, devices, offline: [] }, rest = Sekunden bis Start
export function Countdown({ rest, run, onStop, onClose, busy }) {
  const laeuft = rest === 0;
  return (
    <div className="fixed inset-0 z-50 bg-gray-950/95 text-white flex flex-col items-center justify-center px-6" data-testid="messe-countdown">
      <p className="text-xs uppercase tracking-[0.3em] text-fuchsia-400 font-semibold mb-6">{laeuft ? "Durchsage läuft" : "Start in"}</p>
      <div key={rest} className={`font-black tabular-nums leading-none ${laeuft ? "text-5xl" : "text-[9rem]"} messe-count-pop`} data-testid="messe-countdown-value">
        {laeuft ? <span className="flex items-center gap-3"><Volume2 className="w-12 h-12 text-fuchsia-400" /> {run.label}</span> : rest}
      </div>
      {!laeuft && <p className="mt-6 text-sm text-gray-400">„{run.label}“ auf {run.devices} Gerät{run.devices === 1 ? "" : "en"}</p>}
      {run.offline.length > 0 && <p className="mt-2 text-xs text-amber-300">offline: {run.offline.join(", ")}</p>}
      <div className="mt-12 flex gap-3">
        <button type="button" disabled={busy} onClick={onStop} className="h-12 px-6 rounded-xl bg-white text-gray-900 font-semibold flex items-center gap-2 disabled:opacity-40" data-testid="messe-countdown-stop"><Square className="w-4 h-4" /> Stopp</button>
        {laeuft && <button type="button" onClick={onClose} className="h-12 px-6 rounded-xl border border-gray-600 text-gray-200 font-semibold" data-testid="messe-countdown-close">Schließen</button>}
      </div>
      <style>{`@keyframes messePop{0%{transform:scale(1.35);opacity:.2}100%{transform:scale(1);opacity:1}} .messe-count-pop{animation:messePop .45s cubic-bezier(.2,.8,.2,1)}`}</style>
    </div>
  );
}
